import { Directive, Input } from '@angular/core';
import { ControlContainer, NgControl } from '@angular/forms';

@Directive({
  selector: `
  [formControl][appFormFINDisabled],
  [formControlName][appFormFINDisabled],
  `,
  standalone: true
})
export class FormFINDisabledDirective {

  constructor(private ngControl: NgControl) { }

  @Input('appFormFINDisabled') set disabledIf(condition: boolean) {
    const control = this.ngControl.control;

    condition ? control?.disable() : control?.enable();
  }
}

@Directive({
  selector: `
  [formGroup][appFormFINDisabled],
  [formGroupName][appFormFINDisabled],
  [formArrayName][appFormFINDisabled],
  `,
  standalone: true
})

export class ContainerFormFINDisabledDirective {
  @Input('appFormCcpDisabled') set disabledIf(condtion: boolean) {
    const container = this.controlContainer.control;


    condtion ? container?.disable() : container?.enable();
  }

  constructor(private controlContainer: ControlContainer) { }

}
